export default __webpack_public_path__ + "medium-high-density.png";